import Avatar from "@/components/common/Avatar";
import { UserOutlined } from "@/config/antd";
import PropTypes from "prop-types";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { useNavigate } from "react-router-dom";

const CandidateCard = ({ id, name, position, location, avatar }) => {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    // Prevent navigation if clicking on more options
    if (e.target.closest("button")) return;
    navigate(`/dashboard/candidates/${id}`);
  };

  return (
    <div
      className="flex justify-between p-2 mb-4 text-left bg-[var(--header-bg)] cursor-pointer lg:mb-0 rounded-xl lg:border-transparent lg:bg-[#F2F9FFD6]"
      onClick={handleCardClick}>
      <div className="flex items-center gap-4">
        <Avatar size={56} src={avatar} className="border-2 border-gray-100" />
        <div className="flex flex-col gap-1">
          <h3 className="text-base font-bold">{name}</h3>
          <div className="flex flex-col">
            <div className="flex items-center gap-2 mb-1">
              <UserOutlined className="text-gray-500" />
              <span className="text-small text-lighterGrey">{position}</span>
            </div>
            <span className="ml-6 text-small text-lighterGrey lg:hidden">
              {location}
            </span>
          </div>
        </div>
      </div>
      <button className="p-2 rounded-full hover:bg-gray-100">
        <CustomMoreOptions variant="outlined" />
      </button>
    </div>
  );
};

CandidateCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  location: PropTypes.string,
  avatar: PropTypes.string,
};

export default CandidateCard;
